import React, { useState, useRef } from 'react';
import api from "../../../services/api";
import NotificationAlert from "react-notification-alert";
import Filters from './Filters'

// reactstrap components
import Table from './Table';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'

export default ({ ...props }) => {

    const [loading, setLoading] = useState(false)
    const [alert, setAlert] = useState(null)
    const [perfis, setPerfis] = useState([])
    const [pageProperties, setPageProperties] = useState({
        total: "0",
        perPage: 10,
        page: 1,
        lastPage: 1,
        loading: false
    })
    const [lastSearch, setLastSearch] = useState({})
    const [filtersOpen, setFiltersOpen] = useState(false)
    const [clearTrigger, setClearTrigger] = useState(0)
    const notificationAlert = useRef();
   
    function notify(type, msg) {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7
        };
        if (notificationAlert) notificationAlert.current.notificationAlert(options);
    };

    function onNewClicked(e) {
        e.preventDefault();
        props.history.push('perfis/new')
    }

    async function updatePageProperties(response) {
        const { total, perPage, page, lastPage } = await response.data
        await setPageProperties({
            total,
            perPage,
            page,
            lastPage,
            loading: false,
        })
    }

    async function loadPerfis(page = 1,
        limit = 10,
        sortField = "created_at",
        sortOrder = "desc",
        filters = lastSearch) {
        try {
            setPageProperties({
                ...pageProperties,
                loading: true
            })
            const response = await api.get(`security/perfis/`, {
                params: {
                    page,
                    limit,
                    sortField,
                    sortOrder,
                    ...filters
                }
            })
            setPerfis(response.data)
            await updatePageProperties(response)
        } catch (err) {
            console.log(err.response)
            notify('danger', 'Houve um problema ao carregar os perfis.');
        }
    }


    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder }) => {
        try {
            await loadPerfis(page == 0 ? 1 : page, sizePerPage, sortField, sortOrder)
        } catch (error) {
            notify('danger', 'Houve um problema ao carregar os perfis.');
        }
    }

    return (
        <>
            {alert}
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlert} />
            </div>
            <SimpleHeader name="Listagem de perfis" parentName="Perfis" {...props} />
            <div className="w-100">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h1 className="mb-0">Perfis</h1>
                                <div className="d-flex" style={{ gap: '8px' }}>
                                    <Button
                                        color="secondary"
                                        outline
                                        size="sm"
                                        style={{ height: '32px' }}
                                        onClick={() => setFiltersOpen(!filtersOpen)}
                                    >
                                        <span className="btn-inner--icon">
                                            <i className="fa fa-filter" />
                                        </span>
                                        <span className="btn-inner--text"> Filtros</span>
                                    </Button>
                                    <Button
                                        color="secondary"
                                        outline
                                        size="sm"
                                        style={{ height: '32px' }}
                                        onClick={() => setClearTrigger(Date.now())}
                                    >
                                        <span className="btn-inner--icon">
                                            <i className="fa fa-trash" />
                                        </span>
                                        <span className="btn-inner--text"> Limpar Filtros</span>
                                    </Button>
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={e => onNewClicked(e)}
                                        size="sm">
                                        <span className="btn-inner--icon">
                                            <i className="ni ni-fat-add" />
                                        </span>
                                        Novo Perfil
                                    </Button>
                                </div>
                            </CardHeader>
                            <Filters
                                isOpen={filtersOpen}
                                clearTrigger={clearTrigger}
                                data={perfis}

                                load={(filters) => {
                                    setLastSearch(filters)
                                    loadPerfis(
                                        1,
                                        10,
                                        "name",
                                        "desc",
                                        filters)
                                }}
                            />
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Table
                                            perfis={perfis ? perfis.data : []}
                                            notify={notify}
                                            onTableChange={handleTableChange}
                                            history={props.history}
                                            pageProperties={pageProperties}
                                            loading={loading}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
